/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountRoleName } from './accountRoleName';


/**
 * Spec for creation IAM role in account.
 */
export interface AccountRoleCreationSpec { 
    name: AccountRoleName;
}
export namespace AccountRoleCreationSpec {
}


